import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FgaService } from './fga.service';
import { FgaDirective } from './fga.directive';
import { ModuleFgaDirective } from './module-fga.directive';

@NgModule({
  declarations: [],
  imports: [CommonModule, FgaDirective, ModuleFgaDirective],
  providers: [FgaService],
  exports: [FgaDirective, ModuleFgaDirective],
})
export class FgaModule {}
